import script from "./cxInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./cxInfoList.vue?vue&type=script&setup=true&lang=js"

import "./cxInfoList.vue?vue&type=style&index=0&id=f05e019c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f05e019c"]])

export default __exports__